<template>
  <div id="qrcode" style="width:120px; height:120px;margin: auto;"></div>
</template>
<script>

require('@/utils/qrcode.js')
export default {
  mounted() {
    this.qrcode()
  },
  methods: {
    createQrcode(data) {
      var qrcode = new QRCode(document.getElementById(data.idEl), {
        width: data.size,
        height: data.size,
      });
      qrcode.makeCode(data.text);
    },
    qrcode() {
      this.createQrcode({
        text: window.location.origin + "/download.html",
        idEl: "qrcode",
        size: 120
      });
    },
  }
}
</script>